import React from 'react'
import PropTypes from 'prop-types'

import Box from '@material-ui/core/Box'

import { makeStyles } from '@material-ui/core/styles'

// I had to style some of the elements using traditional css (see index.css) as I couldn't work out how to get :first-child etc working in React
const useStyles = makeStyles({
  button: (selected) => ({
    backgroundColor: selected ? '#1f2651' : '#e8e9ee',
    cursor: 'pointer'
  }),
  wrapper: {
    position: 'relative'
  },
  buttonIcon: {
    '& img': {
      height: '24px'
    }
  },
  buttonText: (selected) => ({
    fontSize: '16px',
    color: selected ? 'white' : '#1e2552',
    fontWeight: 500,
    fontFamily: 'Fira Sans',
    overflowX: 'hidden',
    // whiteSpace: 'nowrap',
    textAlign: 'center'
  })
})

export default function HotkeyNavigationButton (props) {
  const {
    text,
    icon,
    onClick,
    selected = false
  } = props

  const classes = useStyles(selected)

  const path = selected ? 'dark' : 'light'

  return (
    <Box
      className={classes.wrapper}
      flex={1}
      onClick={(event) => onClick && onClick(event)}
    >
      <Box
        className={classes.button}
        height={80}
        display="flex"
        justifyContent="center"
        flexDirection="column"
      >
        <Box className={classes.buttonIcon} display="flex" alignItems="center" justifyContent="center">
          <img src={require(`../../assets/img/icons/hotkeys/${path}/${icon}.svg`)} />
        </Box>
        <Box className={classes.buttonText} display="flex" alignItems="center" justifyContent="center">
          {text}
        </Box>
      </Box>
    </Box>
  )
}

HotkeyNavigationButton.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  selected: PropTypes.bool
}
